import axios, { AxiosRequestConfig } from 'axios'
import { decryptAES } from '../util/cipher'
import { createBrowserHistory } from 'history'

const history = createBrowserHistory()

axios.interceptors.request.use(
    function (configs) {
        const url = globalThis.location.href
        let refId: string | null = ''

        if (url.includes('feedback') && !url.includes('report-feedback')) {
            refId = globalThis.sessionStorage.getItem(`${process.env.REACT_APP_ACCESS_TOKEN_USER}`)
        } else {
            refId = globalThis.sessionStorage.getItem(`${process.env.REACT_APP_ACCESS_TOKEN_NBTC}`)
            if (!refId) {
                const localRefIdStorage = globalThis.localStorage.getItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
                const localRefId = localRefIdStorage ? JSON.parse(decryptAES(localRefIdStorage)) : null

                if (localRefId) {
                    globalThis.sessionStorage.setItem(
                        `${process.env.REACT_APP_ACCESS_TOKEN_NBTC}`,
                        localRefId.accessToken,
                    )
                    refId = localRefId.accessToken
                }
            }
        }

        configs.headers = {
            Authorization: `Bearer ${refId}`,
            'x-api-key': `${process.env.REACT_APP_API_KEY}`,
        }
        return configs
    },
    function (error) {
        throw error
    },
)

function ConfigAPI(): AxiosRequestConfig {
    return {
        headers: {
            // 'x-api-key': `${process.env.REACT_APP_API_KEY}`,
            // example
            // 'x-api-key': 'something...'
            // authorization: token,
        },
    }
}

export default ConfigAPI()
